import { useGetPricing } from '@/api/gen/pricing/pricing.gen';
import {
  getDisplayCurrency,
  getDisplayFinalPrice,
  getDisplayOriginalPrice,
} from '@/module/payment/shared/utils/displayPricing';
import { type PlanType } from '@/types/UserInfo';

type Plans = Record<
  PlanType,
  {
    currency?: string;
    finalPrice?: number;
    displayCurrency?: string;
    displayOriginalPrice?: number;
    displayFinalPrice?: number;
  }
>;

export const usePrices = (params: {
  countryCode: string;
  planType: PlanType;
}) => {
  const { countryCode, planType } = params;

  const { data } = useGetPricing({
    countryCode,
  });

  const plan = (data?.data.plans as unknown as Plans)?.[planType];
  const countryPricingDisplayCurrency = (
    data?.data as { displayCurrency?: string } | undefined
  )?.displayCurrency;
  const finalPrice = plan?.finalPrice ?? 0;
  const displayOriginalPrice = getDisplayOriginalPrice({
    ...plan,
    finalPrice,
  });
  const displayFinalPrice = getDisplayFinalPrice({
    ...plan,
    finalPrice,
  });
  const displayCurrency = getDisplayCurrency({
    ...plan,
    displayCurrency: plan?.displayCurrency ?? countryPricingDisplayCurrency,
    currency: plan?.currency ?? data?.data.currency,
  });
  const discountRate =
    0 < displayOriginalPrice
      ? Math.round(
          ((displayOriginalPrice - displayFinalPrice) / displayOriginalPrice) *
            100,
        )
      : 0;

  // activePromotions에서 현재 planType에 해당하는 프로모션 찾기
  const activePromotion =
    data?.data.activePromotions?.find(promo =>
      promo.targetPlanTypes.includes(planType),
    ) ?? null;

  return {
    finalPrice,
    displayOriginalPrice,
    displayFinalPrice,
    displayCurrency,
    discountRate,
    activePromotion,
  };
};
